import { NodeViewWrapper } from "@tiptap/react";
import { NodeViewProps } from "@tiptap/core";
import { cn } from "@/lib/utils";

export const VideoNodeView = ({ node, selected }: NodeViewProps) => {
  const { src, poster, caption, width, height, align } = node.attrs;

  if (!src) {
    return (
      <NodeViewWrapper>
        <div className="flex items-center justify-center rounded-lg border border-dashed border-gray-300 bg-gray-50 p-8 dark:border-gray-700 dark:bg-gray-900">
          <p className="text-sm text-gray-500 dark:text-gray-400">
            No video source provided
          </p>
        </div>
      </NodeViewWrapper>
    );
  }

  const alignmentClasses = {
    left: "text-left mr-auto",
    center: "text-center mx-auto",
    right: "text-right ml-auto",
  };

  const containerClass = alignmentClasses[align as keyof typeof alignmentClasses] || alignmentClasses.center;

  return (
    <NodeViewWrapper>
      <figure
        className={cn(
          "relative my-4 select-none",
          containerClass,
          selected && "ring-2 ring-blue-500 ring-offset-2 rounded-lg"
        )}
        style={{
          maxWidth: typeof width === "number" ? `${width}px` : width,
        }}
      >
        <div className="relative overflow-hidden rounded-lg bg-black">
          <video
            src={src}
            poster={poster || undefined}
            controls
            className="h-auto w-full"
            style={{
              maxWidth: "100%",
              height: typeof height === "number" ? `${height}px` : height,
            }}
            playsInline
          >
            <track kind="captions" />
            Your browser does not support the video tag.
          </video>
        </div>

        {caption && (
          <figcaption className="mt-2 text-center text-sm text-gray-600 dark:text-gray-400">
            {caption}
          </figcaption>
        )}
      </figure>
    </NodeViewWrapper>
  );
};
